export const createElasticSearchRepository = (appFetch) => {
    return {
        search(options) {
            return appFetch.get('/api/v1/search', options);
        },
    };
};
